import { type FormEvent } from "react";

import { Alert, Button, Modal, TextInput } from "@icg360/design-system";

import styles from "./user-input.module.scss";

export const UserInput = ({ onClose }) => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const input = e.currentTarget.elements.namedItem(
      "email"
    ) as HTMLInputElement;
    const url = new URL(window.location.href);
    url.searchParams.set("user", input.value);
    window.location.assign(url);
  };

  return (
    <Modal heading="Impersonate user" onClose={onClose} open noFooter>
      <Alert
        appearance="danger"
        title="Caution!"
        description=" Any changes made while impersonating a user will be applied to their account."
      />
      <form onSubmit={handleSubmit} className={styles.form}>
        <TextInput name="email" placeholder="user@example.com" />
        <Button type="submit">Submit</Button>
      </form>
    </Modal>
  );
};
